<div class="container-modal-custom-colors">
    <div class="col-12 p-0 title-modal">
        <p class="mb-3" *ngIf="data.create">{{ 'app.diseno.themes.crear_tema' | translate }}</p>
        <p class="mb-3" *ngIf="!data.create">{{ 'app.diseno.themes.editar_tema' | translate }}</p>
    </div>
    <form [formGroup]="customThemeContentForm" class="col-12 d-flex flex-column p-0">
        <p class="col-12 p-0 m-0 mb-1 customize-subtitle">{{ 'app.diseno.themes.colores' | translate }}</p>
        <div class="col-12 col-md-6 d-flex flex-column flex-sm-row justify-content-md-between p-0">
            <div class="d-flex flex-column mt-1 mr-sm-4 mr-md-0">
                <div class="label-input-color">
                    <p class="m-0 customize-label" for="primary_color">
                        {{ 'app.diseno.themes.color_principal' | translate }}
                    </p>
                </div>
                <div class="d-flex align-items-center container-color mt-1">
                    <input class="p-0 input-color-2" type="color" formControlName="primary_color" />
                    <ss-form-group-input
                        [form]="customThemeContentForm"
                        name="primary_color_input"
                        type="text"
                        autocomplete="off"
                        [disabled]="false"
                    >
                    </ss-form-group-input>
                </div>
            </div>

            <div class="d-flex flex-column mt-1">
                <div class="label-input-color">
                    <p class="m-0 customize-label" for="secondary_color">
                        {{ 'app.diseno.themes.color_secundario' | translate }}
                    </p>
                </div>
                <div class="d-flex align-items-center container-color mt-1 ml-2">
                    <input class="p-0 input-color-2" type="color" formControlName="secondary_color" />
                    <ss-form-group-input
                        [form]="customThemeContentForm"
                        name="secondary_color_input"
                        type="text"
                        autocomplete="off"
                        [disabled]="false"
                    >
                    </ss-form-group-input>
                </div>
            </div>
        </div>
        <div class="container-text d-flex align-items-center col-12 col-md-6 mt-2 p-2">
            <i class="fal fa-info-circle"></i>
            <ul class="pl-4 m-0">
                <li>{{ 'app.diseno.themes.color_primario' | translate }}</li>
                <li>{{ 'app.diseno.themes.color_oscuro' | translate }}</li>
            </ul>
        </div>
    </form>

    <div class="col-12 p-0 mt-3">
        <p class="customize-subtitle d-flex align-items-center p-0 m-0 mb-1">
            {{ 'app.diseno.themes.encabezado' | translate }}
            <i
                class="fal fa-info-circle ss-tooltip ml-2"
                ngbTooltip="{{ 'app.diseno.themes.tooltip_header' | translate }}"
                [triggers]="trigger"
                [autoClose]="'outside'"
                placement="right"
                [tooltipClass]="tooltipCustomClass"
            >
            </i>
        </p>
    </div>
    <form
        [formGroup]="customThemeHeaderForm"
        class="col-12 col-md-6 d-flex flex-column flex-sm-row p-0 justify-content-md-between"
    >
        <div class="d-flex flex-column mt-1 mr-sm-4 mr-md-0">
            <div class="label-input-color">
                <p class="m-0 customize-label" for="color">
                    {{ 'app.diseno.themes.fondo' | translate }}
                </p>
            </div>
            <div class="d-flex align-items-center container-color mt-1">
                <input class="p-0 input-color-2" type="color" formControlName="color" />
                <ss-form-group-input
                    [form]="customThemeHeaderForm"
                    name="color_input"
                    type="text"
                    autocomplete="off"
                    [disabled]="false"
                >
                </ss-form-group-input>
            </div>
        </div>

        <div class="d-flex flex-column mt-1">
            <div class="label-input-color">
                <p class="m-0 customize-label" for="font_color">
                    {{ 'app.diseno.themes.fuente' | translate }}
                </p>
            </div>
            <div class="d-flex align-items-center container-color mt-1 ml-2">
                <input class="p-0 input-color-2" type="color" formControlName="font_color" />
                <ss-form-group-input
                    [form]="customThemeHeaderForm"
                    name="font_color_input"
                    type="text"
                    autocomplete="off"
                    [disabled]="false"
                >
                </ss-form-group-input>
            </div>
        </div>
    </form>

    <div class="col-12 p-0 mt-3">
        <p class="customize-subtitle d-flex align-items-center p-0 m-0 mb-1">
            {{ 'app.diseno.themes.footer' | translate }}
            <i
                class="fal fa-info-circle ss-tooltip ml-2"
                ngbTooltip="{{ 'app.diseno.themes.tooltip_footer' | translate }}"
                [triggers]="trigger"
                [autoClose]="'outside'"
                placement="right"
                [tooltipClass]="tooltipCustomClass"
            >
            </i>
        </p>
    </div>
    <form
        [formGroup]="customThemeFooterForm"
        class="col-12 col-md-6 d-flex flex-column flex-sm-row p-0 justify-content-md-between"
    >
        <div class="d-flex flex-column mt-1 mr-sm-4 mr-md-0">
            <div class="label-input-color">
                <p class="m-0 customize-label" for="color">
                    {{ 'app.diseno.themes.fondo' | translate }}
                </p>
            </div>
            <div class="d-flex align-items-center container-color mt-1">
                <input class="p-0 input-color-2" type="color" formControlName="color" />
                <ss-form-group-input
                    [form]="customThemeFooterForm"
                    name="color_input"
                    type="text"
                    autocomplete="off"
                    [disabled]="false"
                >
                </ss-form-group-input>
            </div>
        </div>

        <div class="d-flex flex-column mt-1">
            <div class="label-input-color">
                <p class="m-0 customize-label" for="font_color">
                    {{ 'app.diseno.themes.fuente' | translate }}
                </p>
            </div>
            <div class="d-flex align-items-center container-color mt-1 ml-2">
                <input class="p-0 input-color-2" type="color" formControlName="font_color" />
                <ss-form-group-input
                    [form]="customThemeFooterForm"
                    name="font_color_input"
                    type="text"
                    autocomplete="off"
                    [disabled]="false"
                >
                </ss-form-group-input>
            </div>
        </div>
    </form>

    <div class="preview-colores col-12 col-md-5 p-0 my-5 my-md-0">
        <div class="h-100 w-100 container-preview d-flex flex-column justify-content-between">
            <div
                class="header-preview py-3"
                [ngStyle]="{
                    'background-color': customThemeHeaderForm.controls.color.value,
                    color: customThemeHeaderForm.controls.font_color.value
                }"
            >
                <div class="col-2 p-0 pl-2 d-flex align-items-center">
                    <i class="fas fa-circle mr-1" style="font-size: 20px"></i>
                </div>
                <div class="col-8 p-0 d-flex align-items-center justify-content-center">
                    <p class="m-0" [style.fontFamily]="customThemeContentForm.controls.font.value">
                        {{ 'app.diseno.themes.encabezado' | translate }}
                    </p>
                </div>
                <div class="col-2 d-flex align-items-center justify-content-end p-0 pr-2">
                    <i class="fas fa-circle mr-1"></i>
                    <i class="fas fa-circle mr-1"></i>
                    <i class="fas fa-circle"></i>
                </div>
            </div>
            <div class="body-preview" style="background-color: #ffffff">
                <div
                    class="col-9"
                    [ngStyle]="{ 'background-color': customThemeContentForm.controls.primary_color.value }"
                ></div>
                <div
                    class="col-12"
                    [ngStyle]="{ 'background-color': customThemeContentForm.controls.secondary_color.value }"
                ></div>
                <div
                    class="col-3"
                    [ngStyle]="{ 'background-color': customThemeContentForm.controls.secondary_color.value }"
                ></div>
                <div
                    class="col-3"
                    [ngStyle]="{ 'background-color': customThemeContentForm.controls.secondary_color.value }"
                ></div>
                <div
                    class="col-1"
                    [ngStyle]="{ 'background-color': customThemeContentForm.controls.secondary_color.value }"
                ></div>
                <div
                    class="col-2"
                    [ngStyle]="{ 'background-color': customThemeContentForm.controls.secondary_color.value }"
                ></div>
                <div
                    class="col-1"
                    [ngStyle]="{ 'background-color': customThemeContentForm.controls.primary_color.value }"
                ></div>
                <div
                    class="col-12"
                    [ngStyle]="{ 'background-color': customThemeContentForm.controls.secondary_color.value }"
                ></div>
                <div class="col-3 card p-1" style="background-color: #ffffff">
                    <div
                        class="w-100 box"
                        [ngStyle]="{ 'background-color': customThemeContentForm.controls.primary_color.value }"
                    ></div>
                    <div
                        class="w-100 mt-1 box"
                        [ngStyle]="{ border: '2px solid ' + customThemeContentForm.controls.primary_color.value }"
                    ></div>
                </div>
                <div class="col-3 card p-1" style="background-color: #ffffff">
                    <div
                        class="w-100 box"
                        [ngStyle]="{ 'background-color': customThemeContentForm.controls.primary_color.value }"
                    ></div>
                    <div
                        class="w-100 mt-1 box"
                        [ngStyle]="{ border: '2px solid ' + customThemeContentForm.controls.primary_color.value }"
                    ></div>
                </div>
                <div class="col-3 card p-1" style="background-color: #ffffff">
                    <div
                        class="w-100 box"
                        [ngStyle]="{ 'background-color': customThemeContentForm.controls.primary_color.value }"
                    ></div>
                    <div
                        class="w-100 mt-1 box"
                        [ngStyle]="{ border: '2px solid ' + customThemeContentForm.controls.primary_color.value }"
                    ></div>
                </div>
                <div class="col-12 p-0 container-textPreview p-1">
                    <div
                        class="col-12 text-preview mt-1"
                        [ngStyle]="{ 'background-color': customThemeContentForm.controls.secondary_color.value }"
                    ></div>
                    <div
                        class="col-12 text-preview mt-2"
                        [ngStyle]="{ 'background-color': customThemeContentForm.controls.secondary_color.value }"
                    ></div>
                    <div
                        class="col-12 text-preview mt-2"
                        [ngStyle]="{ 'background-color': customThemeContentForm.controls.secondary_color.value }"
                    ></div>
                    <div
                        class="col-4 text-preview mt-2 mx-auto"
                        [ngStyle]="{ 'background-color': customThemeContentForm.controls.primary_color.value }"
                    ></div>
                </div>
            </div>
            <div
                class="footer-preview p-3 text-center"
                [ngStyle]="{
                    'background-color': customThemeFooterForm.controls.color.value,
                    color: customThemeFooterForm.controls.font_color.value
                }"
            >
                <p class="m-0" [style.fontFamily]="customThemeContentForm.controls.font.value">
                    {{ 'app.diseno.themes.footer' | translate }}
                </p>
            </div>
        </div>
    </div>
    <div class="d-flex col-12 justify-content-end p-0 mt-4">
        <button [disabled]="loading" class="btn btn-skip mr-2" (click)="close()">
            {{ 'app.diseno.themes.cancelar' | translate }}
        </button>
        <button [disabled]="loading || !customThemeContentForm.valid" class="btn btn-continue" (click)="submit()">
            <mc-loading *ngIf="loading" color="text-white" size="sm"></mc-loading>
            <span *ngIf="data.create"> {{ 'app.diseno.themes.crear' | translate }} </span>
            <span *ngIf="!data.create"> {{ 'app.diseno.themes.aplicar' | translate }} </span>
        </button>
    </div>
</div>
